import React from 'react';
import { Button } from 'semantic-ui-react';

const Body = ({ data }) => {
  return (
    <>
      <div className="newsletter">
        <div className="pt-3 pb-2 white">
          <div className="flex justify-center text mb-1">
            Iscriviti alla Newsletter del Servizio Attività Culturali
          </div>
          <Button
            color="yellow"
            type="button"
            as="a"
            href="https://attivitaculturaliimola.voxmail.it/user/register"
            target="_blank"
            rel="noopener noreferrer"
          >
            Vai alla Newsletter
          </Button>
        </div>
      </div>
    </>
  );
};

export default Body;
